export const STORAGE_KEY = 'nosgestesclimat::v3'
